// src/pages/BettingPage.jsx
import React, { useState, useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { authService } from '../services/authService';
import './BettingPage.css';
import toast, { Toaster } from 'react-hot-toast';
// Define valid numbers for each game type
const doublePanaList = [
  "100", "110", "112", "113", "114", "115", "116", "117", "118", "119", "122", "133", "144", "155", "166", "177", "188", "199", "200", "220", "223", "224", "225", "226","227", "228",
  "229", "233", "244", "255", "266", "277", "288", "299", "300", "330", "334", "335", "336", "337", "338", "339", "344", "355", "366", "377", "388", "399","400", "440", "445", "446",
  "447", "448", "449", "449", "455", "466", "477", "488", "499", "500", "550", "556", "557", "558", "559", "566","577", "588", "599", "600", "660", "667", "668", "669", "677", "688",
  "699", "700", "770", "778", "779", "788", "799", "800", "880", "889", "899", "900", "990"
];

const singlePanaList = [
  "120", "123", "124", "125", "126", "127", "128", "129", "130", "134", "135", "136", "137", "138", "139", "140", "145", "146", "147", "148", "149", "150", "156", "157", "158", "159",
  "160", "167", "168", "169", "170", "178", "179", "180", "189", "190", "230", "234", "235", "236", "237", "238", "239", "240", "245", "246", "247", "248", "249", "250", "256", "257",
  "258", "259", "260", "267", "268", "269", "270", "278", "279", "280", "289", "290", "340", "345", "346", "347", "348", "349", "350", "356", "357", "358", "359", "360", "367", "368",
  "369", "370", "378", "379", "380", "389", "390", "450", "456", "457", "458", "459", "460", "467", "468", "469", "470", "478", "479", "480", "489", "490", "560", "567", "568", "569",
  "570", "578", "579", "580", "589", "590", "670", "678", "679", "680", "689", "690", "780", "789", "790", "890",
];

const triplePanaList = [
  '000', '111', '222', '333', '444', '555', '666', '777', '888', '999'
];

const sangamList = [
  "000", "100", "110", "111", "112", "113", "114", "115", "116", "117", "118", "119", "120", "122", "123", "124", "125", "126", "127", "128", "129", "130", "133", "134", "135",
  "136", "137", "138", "139", "140", "144", "145", "146", "147", "148", "149", "150", "155", "156", "157", "158", "159", "160", "166", "167", "168", "169", "170", "177", "178",
  "179", "180", "188", "189", "190", "199", "200", "220", "222", "223", "224", "225", "226", "227", "228", "229", "230", "233", "234", "235", "236", "237", "238", "239", "240",
  "244", "245", "246", "247", "248", "249", "250", "255", "256", "257", "258", "259", "260", "266", "267", "268", "269", "270", "277", "278", "279", "280", "288", "289", "290",
  "299", "300", "330", "333", "334", "335", "336", "337", "338", "339", "340", "344", "345", "346", "347", "348", "349", "350", "355", "356", "357", "358", "359", "360", "366",
  "367", "368", "369", "370", "377", "378", "379", "380", "388", "389", "390", "399", "400", "440", "444", "445", "446", "447", "448", "449", "450", "455", "456", "457", "458",
  "459", "460", "466", "467", "468", "469", "470", "477", "478", "479", "480", "488", "489", "490", "499", "500", "550", "555", "556", "557", "558", "559", "560", "566", "567",
  "568", "569", "570", "577", "578", "579", "580", "588", "589", "590", "599", "600", "660", "666", "667", "668", "669", "670", "677", "678", "679", "680", "688", "689", "690",
  "699", "700", "770", "777", "778", "779", "780", "788", "789", "790","799", "800", "880", "888", "889", "890", "899", "900", "990", "999"
];

// Valid single digits (0-9)
const singleDigits = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
// Valid Jodi digits (00-99)
const generateJodiDigits = () => {
  const jodiList = [];
  for (let i = 0; i <= 99; i++) {
    jodiList.push(i.toString().padStart(2, '0'));
  }
  return jodiList;
};
const jodiDigitsList = generateJodiDigits();

// Confirmation Modal Component
const ConfirmationModal = ({ isOpen, onClose, onConfirm, betDetails }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <h3>Confirm Bet Placement</h3>
          <button className="modal-close-btn" onClick={onClose}>
            ×
          </button>
        </div>
        
        <div className="modal-body">
          <div className="bet-summary">
            <h4>Bet Summary</h4>
            <div className="summary-item">
              <span className="summary-label">Game:</span>
              <span className="summary-value">{betDetails.gameName}</span>
            </div>
            <div className="summary-item">
              <span className="summary-label">Game Type:</span>
              <span className="summary-value">{betDetails.gameType}</span>
            </div>
            <div className="summary-item">
              <span className="summary-label">Total Bets:</span>
              <span className="summary-value">{betDetails.totalBets}</span>
            </div>
            <div className="summary-item">
              <span className="summary-label">Total Points:</span>
              <span className="summary-value highlight">{betDetails.totalPoints}</span>
            </div>
           
            <div className="summary-item">
              <span className="summary-label">Date:</span>
              <span className="summary-value">{betDetails.date}</span>
            </div>
          </div>

          <div className="bid-details">
            <h4>Bid Details:</h4>
            <div className="bids-list">
              {betDetails.bids.map((bid, index) => (
                <div key={index} className="bid-item">
                  <div className="bid-number">
                    {betDetails.isSangam ? (
                      <>
                        {bid.type === 'half_sangam' ? (
                          bid.halfSangamOption === 'open_digit_close_pana' ? (
                            <>
                              <span>{bid.digits} (Open Digit)</span>
                              <span> → </span>
                              <span>{bid.closedigits} (Close Pana)</span>
                            </>
                          ) : (
                            <>
                              <span>{bid.digits} (Open Pana)</span>
                              <span> → </span>
                              <span>{bid.closedigits} (Close Digit)</span>
                            </>
                          )
                        ) : (
                          <>
                            <span>{bid.digits}</span>
                            {bid.closedigits && <span> → {bid.closedigits}</span>}
                          </>
                        )}
                      </>
                    ) : (
                      <span>{bid.digits}</span>
                    )}
                  </div>
                  <div className="bid-info">
                    <span className="bid-points">{bid.points} Points</span>
                    {bid.session && !betDetails.isSangam && !betDetails.isJodi && !betDetails.isMotor && (
                      <span className="bid-session">({bid.session})</span>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="confirmation-warning">
            <p>⚠️ Please review your bet details carefully before confirming.</p>
            <p>Once confirmed, the bet cannot be cancelled.</p>
          </div>
        </div>

        <div className="modal-footer">
          <button className="modal-cancel-btn" onClick={onClose}>
            Cancel
          </button>
          <button className="modal-confirm-btn" onClick={onConfirm}>
            Confirm & Place Bet
          </button>
        </div>
      </div>
    </div>
  );
};

// Searchable Dropdown Component
const SearchableDropdown = ({ 
  label, 
  value, 
  onChange, 
  options, 
  placeholder = "Select or search a number",
  disabled = false,
  searchPlaceholder = "Type to search..."
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const dropdownRef = useRef(null);

  // Filter options based on search term
  const filteredOptions = options.filter(option => 
    option.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Handle click outside to close dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSelect = (option) => {
    onChange(option);
    setIsOpen(false);
    setSearchTerm('');
  };

  const displayedValue = value || placeholder;

  return (
    <div className="form-group">
      <label>{label}:</label>
      <div className="searchable-dropdown" ref={dropdownRef}>
        <div 
          className={`dropdown-toggle ${isOpen ? 'open' : ''} ${disabled ? 'disabled' : ''}`}
          onClick={() => !disabled && setIsOpen(!isOpen)}
        >
          <span className={`selected-value ${!value ? 'placeholder' : ''}`}>
            {displayedValue}
          </span>
          <span className="dropdown-arrow">▼</span>
        </div>
        
        {isOpen && !disabled && (
          <div className="dropdown-menu">
            {/* Search input */}
            <div className="dropdown-search">
              <input
                type="text"
                className="search-input"
                placeholder={searchPlaceholder}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                autoFocus
              />
              {searchTerm && (
                <button 
                  className="clear-search"
                  onClick={() => setSearchTerm('')}
                >
                  ×
                </button>
              )}
            </div>

            {/* Options list */}
            <div className="options-list">
              {filteredOptions.length > 0 ? (
                filteredOptions.map((option) => (
                  <div
                    key={option}
                    className={`option-item ${value === option ? 'selected' : ''}`}
                    onClick={() => handleSelect(option)}
                  >
                    {option}
                  </div>
                ))
              ) : (
                <div className="no-results">
                  No results found for "{searchTerm}"
                </div>
              )}
            </div>

            {/* Results count */}
            <div className="results-count">
              Showing {filteredOptions.length} of {options.length} options
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
const MultiSelectDropdown = ({
  label,
  values,
  onChange,
  options,
  placeholder = "Select Numbers",
  disabled = false
}) => {

  const toggleOption = (option) => {
    if (values.includes(option)) {
      onChange(values.filter(v => v !== option));
    } else {
      onChange([...values, option]);
    }
  };
const [searchTerm, setSearchTerm] = useState('');

const filteredOptions = options.filter(option =>
  option.toString().toLowerCase().includes(searchTerm.toLowerCase())
);
  return (
    <div className="form-group">
      <label>{label}</label>

      <div className="multi-select-box">

  <div className="selected-values">
    {values.length
      ? values.join(", ")
      : placeholder}
  </div>

  <input
    type="text"
    className="search-input"
    placeholder="Search..."
    value={searchTerm}
    onChange={(e) => setSearchTerm(e.target.value)}
  />

  <div className="multi-options">

{filteredOptions.map(option => (         
     <button
              type="button"
              key={option}
              disabled={disabled}
              className={
                values.includes(option)
                  ? "multi-item selected"
                  : "multi-item"
              }
              onClick={() => toggleOption(option)}
            >
              {option}
            </button>
          ))}

        </div>
      </div>
    </div>
  );
};
// For Jodi Digit with grouped search
const JodiDropdown = ({ 
  label, 
  value, 
  onChange, 
  disabled = false 
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const dropdownRef = useRef(null);

  // Generate grouped options
  const groupedOptions = Array.from({ length: 10 }, (_, group) => ({
    label: `${group}0 - ${group}9`,
    options: Array.from({ length: 10 }, (_, j) => {
      const num = group * 10 + j;
      return num.toString().padStart(2, '0');
    })
  }));

  // Filter options based on search term
  const filteredGroups = groupedOptions
    .map(group => ({
      label: group.label,
      options: group.options.filter(option => 
        option.includes(searchTerm)
      )
    }))
    .filter(group => group.options.length > 0);

  // Handle click outside to close dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSelect = (option) => {
    onChange(option);
    setIsOpen(false);
    setSearchTerm('');
  };

  const displayedValue = value || "Select Jodi digit (00-99)";

  return (
    <div className="form-group">
      <label>{label}:</label>
      <div className="searchable-dropdown jodi-dropdown" ref={dropdownRef}>
        <div 
          className={`dropdown-toggle ${isOpen ? 'open' : ''} ${disabled ? 'disabled' : ''}`}
          onClick={() => !disabled && setIsOpen(!isOpen)}
        >
          <span className={`selected-value ${!value ? 'placeholder' : ''}`}>
            {displayedValue}
          </span>
          <span className="dropdown-arrow">▼</span>
        </div>
        
        {isOpen && !disabled && (
          <div className="dropdown-menu">
            {/* Search input */}
            <div className="dropdown-search">
              <input
                type="text"
                className="search-input"
                placeholder="Type to search (e.g., 00, 25, 99)"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value.replace(/\D/g, ''))}
                maxLength={2}
                autoFocus
              />
              {searchTerm && (
                <button 
                  className="clear-search"
                  onClick={() => setSearchTerm('')}
                >
                  ×
                </button>
              )}
            </div>

            {/* Options list */}
            <div className="options-list">
              {filteredGroups.length > 0 ? (
                filteredGroups.map((group) => (
                  <div key={group.label} className="option-group">
                    <div className="group-label">{group.label}</div>
                    <div className="group-options">
                      {group.options.map((option) => (
                        <div
                          key={option}
                          className={`option-item ${value === option ? 'selected' : ''}`}
                          onClick={() => handleSelect(option)}
                        >
                          {option}
                        </div>
                      ))}
                    </div>
                  </div>
                ))
              ) : (
                <div className="no-results">
                  No results found for "{searchTerm}"
                </div>
              )}
            </div>

            {/* Results count */}
            <div className="results-count">
              Showing {filteredGroups.reduce((sum, group) => sum + group.options.length, 0)} of 100 options
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

const BettingPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  
  // Get data from navigation state
  const { gameData, selectedGameType } = location.state || {};
  
  // Get game type name
  const gameTypeName = selectedGameType?.game_name || '';
  
  // Check game types
  const isFullSangam = gameTypeName.includes("Full Sangam");
  const isHalfSangam = gameTypeName.includes("Half Sangam");
  const isJodiDigit = gameTypeName.includes("Jodi");
  const isSingleDigit = gameTypeName.includes("Single Digit");
  const isSinglePana = gameTypeName.includes("Single Pana");
  const isDoublePana = gameTypeName.includes("Double Pana");
  const isTriplePana = gameTypeName.includes("Triple Pana");
  const isSPMotor = gameTypeName.includes("SP Motor");
  const isDPMotor = gameTypeName.includes("DP Motor");
  const isSangamGame = isFullSangam || isHalfSangam;
  const isMotorGame = isSPMotor || isDPMotor;

  // State for form
  const [playTime, setPlayTime] = useState('Open');
const [digits, setDigits] = useState([]);
  const [openPanna, setOpenPanna] = useState('');
  const [closePanna, setClosePanna] = useState('');
  const [openAnk, setOpenAnk] = useState('');
  const [closeAnk, setCloseAnk] = useState(''); // For Half Sangam close digit
  const [openPana, setOpenPana] = useState(''); // For Half Sangam open pana
  const [halfSangamOption, setHalfSangamOption] = useState('open_digit_close_pana'); // 'open_digit_close_pana' or 'close_digit_open_pana'
  const [points, setPoints] = useState('');
  const [bids, setBids] = useState([]);
  const [loading, setLoading] = useState(false);
  const [userData, setUserData] = useState(null);
  const [error, setError] = useState('');
  const [currentTime, setCurrentTime] = useState(new Date());
  const [marketStatus, setMarketStatus] = useState({
    openMarketOpen: false,
    closeMarketOpen: false,
    openTimeExceeded: false
  });
  const [bidLimits, setBidLimits] = useState({
    minBidAmount: 10,
    maxBidAmount: 5000
  });

  // Modal state
  const [showConfirmation, setShowConfirmation] = useState(false);
  
  // Check if game only allows Close
  const isCloseOnly = isJodiDigit || isSangamGame;

  // Get token and user data on component mount
  useEffect(() => {
    const token = authService.getToken();
    const currentUser = authService.getCurrentUser();
    
    if (!token) {
      toast.error('Authentication required. Please login to place bets.');
      setError('Authentication required. Please login to place bets.');
    } else {
      setUserData(currentUser);
      fetchBidLimits(token);
    }
  }, []);

  const fetchBidLimits = async () => {
    try {
      const token = authService.getToken();

      if (!token) {
        console.log("No authentication token found");
        return;
      }

      const payload = {
        app_key: "SgRTXsywVmWteEBLlYWecwgbDiHwlh",
        env_type: "Prod",
        unique_jwt_token: token
      };

      const response = await axios.post(
        "https://playinbyd.com/api/api-get-dashboard-data",
        payload,
        {
          headers: {
            "Content-Type": "application/json"
          }
        }
      );
      if (response.data) {
        const { min_bid_amount, max_bid_amount } = response.data;
        setBidLimits({
          minBidAmount: min_bid_amount || 10,
          maxBidAmount: max_bid_amount || 5000
        });
      }
    } catch (error) {
      console.error("Error fetching bid limits:", error);
      // keep defaults if API fails
    }
  };

  // Update current time every minute
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 60000);

    return () => clearInterval(timer);
  }, []);

  // Check market status based on current time
// Check market status based on current time
useEffect(() => {
  if (!gameData?.open_time || !gameData?.close_time) return;

  const now = currentTime;

  const openTime = parseTimeString(gameData.open_time);
  const closeTime = parseTimeString(gameData.close_time);

  // Open market closes 5 min before open time
  const openCutoffTime = new Date(openTime.getTime() - 5 * 60 * 1000);

  // Close market closes 5 min before close time
  const closeCutoffTime = new Date(closeTime.getTime() - 5 * 60 * 1000);

  const openMarketOpen = now < openCutoffTime;
  const closeMarketOpen = now < closeCutoffTime;

  const openTimeExceeded = now >= openCutoffTime;

  setMarketStatus({
    openMarketOpen,
    closeMarketOpen,
    openTimeExceeded
  });

}, [currentTime, gameData]);

  // Parse time string
  const parseTimeString = (timeStr) => {
    if (!timeStr) return new Date();
    
    const today = new Date();
    const [time, modifier] = timeStr.split(' ');
    let [hours, minutes] = time.split(':');
    
    hours = parseInt(hours);
    minutes = parseInt(minutes || 0);
    
    if (modifier === 'PM' && hours < 12) hours += 12;
    if (modifier === 'AM' && hours === 12) hours = 0;
    
    const date = new Date(today);
    date.setHours(hours, minutes, 0, 0);
    return date;
  };

  // Auto-select market type based on rules
  useEffect(() => {
    if (isCloseOnly) {
      setPlayTime('Close');
      
      if (marketStatus.openTimeExceeded) {
        setError(`Betting for ${gameTypeName} is closed. Open time (${gameData?.open_time}) has exceeded.`);
      }
    } else {
      if (marketStatus.openMarketOpen) {
        setPlayTime('Open');
      } else if (marketStatus.closeMarketOpen) {
        setPlayTime('Close');
      }
    }
  }, [isCloseOnly, marketStatus, gameTypeName, gameData]);

  // Validate if number is allowed for the game type
  const isValidNumber = (number, gameType) => {
    if (!number || typeof number !== 'string') return false;
    
    switch(gameType) {
      case 'single_digit':
        return singleDigits.includes(number);
      
      case 'jodi_digit':
        return jodiDigitsList.includes(number);
      
      case 'single_pana':
        return singlePanaList.includes(number);
      
      case 'double_pana':
        return doublePanaList.includes(number);
      
      case 'triple_pana':
        return triplePanaList.includes(number);
      
      case 'full_sangam':
      case 'half_sangam':
        return sangamList.includes(number);
      
      case 'sp_motor':
        // SP Motor uses Single Pana numbers
        return singlePanaList.includes(number);
      
      case 'dp_motor':
        // DP Motor uses Double Pana numbers
        return doublePanaList.includes(number);
      
      default:
        return false;
    }
  };

  // Validate inputs based on game type
  const validateInputs = () => {
    // Check points
    if (!points.trim()) {
      toast.error('Please enter points');
      return false;
    } 
    const pointsNum = parseFloat(points);

    if (pointsNum < bidLimits.minBidAmount || pointsNum > bidLimits.maxBidAmount) {
      toast.error(`Points must be between ${bidLimits.minBidAmount} and ${bidLimits.maxBidAmount}`);
      return false;
    }

    // Validate based on game type
    if (isFullSangam) {
      if (!openPanna.trim() || !closePanna.trim()) {
        toast.error('Please select both Open Panna and Close Panna');
        return false;
      }
      if (!isValidNumber(openPanna.trim(), 'full_sangam')) {
        toast.error('Open Panna is not a valid Sangam number');
        return false;
      }
      if (!isValidNumber(closePanna.trim(), 'full_sangam')) {
        toast.error('Close Panna is not a valid Sangam number');
        return false;
      }
    } else if (isHalfSangam) {
      if (halfSangamOption === 'open_digit_close_pana') {
        if (!openAnk.trim() || !closePanna.trim()) {
          toast.error('Please select both Open Digit and Close Pana');
          return false;
        }
        if (!isValidNumber(openAnk.trim(), 'single_digit')) {
          toast.error('Open Digit must be a digit from 0-9');
          return false;
        }
        if (!isValidNumber(closePanna.trim(), 'full_sangam')) {
          toast.error('Close Pana is not a valid Sangam number');
          return false;
        }
      } else {
        if (!closeAnk.trim() || !openPana.trim()) {
          toast.error('Please select both Close Digit and Open Pana');
          return false;
        }
        if (!isValidNumber(closeAnk.trim(), 'single_digit')) {
          toast.error('Close Digit must be a digit from 0-9');
          return false;
        }
        if (!isValidNumber(openPana.trim(), 'full_sangam')) {
          toast.error('Open Pana is not a valid Sangam number');
          return false;
        }
      }
    } else if (isJodiDigit) {
      if (!digits.length) {
        toast.error('Please select Jodi Digit');
        return false;
      }
      if (!digits.every(d => isValidNumber(d, 'jodi_digit'))) {
        toast.error('Invalid Jodi Digit. Must be between 00-99');
        return false;
      }
    } else if (isSingleDigit) {
      if (!digits.length) {
        toast.error('Please select digit');
        return false;
      }
      if (!digits.every(d => isValidNumber(d, 'single_digit'))) {
        toast.error('Digit must be from 0-9');
        return false;
      }
    } else if (isSinglePana) {
      if (!digits.length) {
        toast.error('Please select Single Pana');
        return false;
      }
      if (!digits.every(d => isValidNumber(d, 'single_pana'))) {
        toast.error('Invalid Single Pana number');
        return false;
      }
    } else if (isDoublePana) {
      if (!digits.length) {
        toast.error('Please select Double Pana');
        return false;
      }
      if (!digits.every(d => isValidNumber(d, 'double_pana'))) {
        toast.error('Invalid Double Pana number');
        return false;
      }
    } else if (isTriplePana) {
      if (!digits.length) {
        toast.error('Please select Triple Pana');
        return false;
      }
      if (!digits.every(d => isValidNumber(d, 'triple_pana'))) {
        toast.error('Invalid Triple Pana number');
        return false;
      }
    } else if (isSPMotor) {
      if (!digits.length) {
        toast.error('Please select SP Motor number');
        return false;
      }
      if (!digits.every(d => isValidNumber(d, 'sp_motor'))) {
        toast.error('Invalid SP Motor number. Must be from Single Pana list');
        return false;
      }
    } else if (isDPMotor) {
      if (!digits.length) {
        toast.error('Please select DP Motor number');
        return false;
      }
      if (!digits.every(d => isValidNumber(d, 'dp_motor'))) {
        toast.error('Invalid DP Motor number. Must be from Double Pana list');
        return false;
      }
    } else {
      toast.error('Invalid game type');
      return false;
    }

    return true;
  };

  const handleAddBid = () => {
    if (isCloseOnly && !marketStatus.closeMarketOpen) {
      toast.error(`Betting for ${gameTypeName} is closed.`);
      return;
    }

    if (playTime === "Open" && !marketStatus.openMarketOpen) {
      toast.error(`Open market betting is closed. Bets stop 15 minutes before open time (${gameData?.open_time}).`);
      return;
    }

    if (playTime === "Close" && !marketStatus.closeMarketOpen) {
      toast.error(`Close market betting is closed. Bets stop 15 minutes before close time (${gameData?.close_time}).`);
      return;
    }

    if (!validateInputs()) return;

    // Create bid object based on game type
    let newBid;
    
    if (isFullSangam) {
      newBid = {
        closedigits: closePanna.trim(),
        digits: openPanna.trim(),
        pana: gameTypeName,
        points: points.trim(),
        session: playTime,
        type: 'full_sangam'
      };
    } else if (isHalfSangam) {
      if (halfSangamOption === 'open_digit_close_pana') {
        newBid = {
          digits: openAnk.trim(),
          closedigits: closePanna.trim(),
          pana: gameTypeName,
          points: points.trim(),
          session: playTime,
          type: 'half_sangam',
          halfSangamOption: 'open_digit_close_pana'
        };
      } else {
        newBid = {
          digits: openPana.trim(), // Open Pana goes in digits field
          closedigits: closeAnk.trim(), // Close digit goes in closedigits field
          pana: gameTypeName,
          points: points.trim(),
          session: playTime,
          type: 'half_sangam',
          halfSangamOption: 'close_digit_open_pana'
        };
      }
    } else {
  const type =
    isSingleDigit ? 'single_digit' :
    isJodiDigit ? 'jodi_digit' :
    isSinglePana ? 'single_pana' :
    isDoublePana ? 'double_pana' :
    isTriplePana ? 'triple_pana' :
    isSPMotor ? 'sp_motor' :
    isDPMotor ? 'dp_motor' :
    'regular';

  const multipleBids = digits.map((digit) => ({
    closedigits: "",
    digits: digit,
    pana: gameTypeName,
    points: points.trim(),
    session: playTime,
    type
  }));

  setBids(prev => [...prev, ...multipleBids]);

  setDigits([]);
  setPoints('');
  setError('');

  toast.success(`${multipleBids.length} bids added successfully`);

  return;
}

    setBids([...bids, newBid]);
    
    // Clear inputs based on game type
    if (isFullSangam) {
      setOpenPanna('');
      setClosePanna('');
    } else if (isHalfSangam) {
      if (halfSangamOption === 'open_digit_close_pana') {
        setOpenAnk('');
        setClosePanna('');
      } else {
        setCloseAnk('');
        setOpenPana('');
      }
    } else {
setDigits([]);
    }
    setPoints('');
    setError('');
    toast.success('Bid added successfully!');
  };

  const handlePlaceBetClick = () => {
    // Check market conditions
    if (isCloseOnly && marketStatus.openTimeExceeded) {
      toast.error(`Betting for ${gameTypeName} is closed. Open time has exceeded.`);
      return;
    }

    if (playTime === 'Open' && !marketStatus.openMarketOpen) {
      toast.error('Cannot place bet: Open market is closed.');
      return;
    }

    if (playTime === 'Close' && !marketStatus.closeMarketOpen) {
      toast.error('Cannot place bet: Close market is closed.');
      return;
    }

    if (bids.length === 0) {
      toast.error('Please add at least one bid');
      return;
    }

    // Show confirmation modal
    setShowConfirmation(true);
  };

  const handleConfirmBet = async () => {
    const token = authService.getToken();
    
    if (!token) {
      toast.error('Authentication token missing. Please login again.');
      setError('Authentication token missing. Please login again.');
      setShowConfirmation(false);
      return;
    }

    setLoading(true);
    setError('');
    
    // Format date as "2025-Dec-18"
    const formatDate = (date) => {
      const d = new Date(date);
      const year = d.getFullYear();
      const month = d.toLocaleString('en-US', { month: 'short' });
      const day = d.getDate().toString().padStart(2, '0');
      return `${year}-${month}-${day}`;
    };

    const payload = {
      app_key: "SgRTXsywVmWteEBLlYWecwgbDiHwlh",
      env_type: "Prod",
      language: "en",
      unique_jwt_token: token,
      new_result: {
        Gamename: gameData?.game_name || "SITA MORNING",
        bid_date: formatDate(new Date()),
        digit_text: gameTypeName,
        gameDB_id: gameData?._id || "694129c9433ce0122824ebaf",
        pana: gameTypeName,
        result: bids,
        session: playTime,
        session_text: "Session",
        totalbit: bids.reduce((sum, bid) => sum + parseInt(bid.points || 0), 0)
      }
    };

    console.log('Sending bet payload:', payload);

    try {
      const response = await axios.post(
        'https://playinbyd.com/api/api-submit-bid',
        payload,
        {
          headers: {
            'Content-Type': 'application/json',
            ...authService.getAuthHeader()
          }
        }
      );

      console.log('API Response:', response.data);
      if (
  response.data?.status === 0 &&
  response.data?.msg?.includes("Already loggedIn other device")
) {
  toast.error(response.data.msg || "Session conflict detected");
authService.logout();
navigate('/login');

  return;
}
      if (response.data.success) {
        toast.success('Bet placed successfully!', {
          duration: 3000, 
          position: 'top-right',
        });        
        // Clear all states
        setBids([]);
setDigits([]);
        setOpenPanna('');
        setClosePanna('');
        setOpenAnk('');
        setCloseAnk('');
        setOpenPana('');
        setPoints('');
        setShowConfirmation(false);
        
        // Redirect after a short delay to show success message
        setTimeout(() => {
          navigate('/game-types', { 
            state: { 
              gameData,
              betPlaced: true,
              successMessage: 'Bet placed successfully!' 
            }
          });
        }, 3500);
      } else {
        setTimeout(() => {
          navigate('/game-types', { 
            state: { 
              gameData,
              betPlaced: true,
              successMessage: 'Bet placed successfully!' 
            }
          });
        }, 1500);
        const errorMsg = response.data.message || 'Failed to place bet';
        toast.error(errorMsg);
        setError(errorMsg);
        setShowConfirmation(false);
      }
    } catch (_error) {
      console.error('API Error:', _error);
      
     if (_error.response?.status === 401 || _error.response?.status === 400) {
  const errorMsg = 'Session expired. Please login again.';
  toast.error(errorMsg);

  setError(errorMsg);

  authService.logout(); // clear token FIRST

  navigate('/login', { replace: true }); // replace history

  return;
}else {
        const errorMsg = _error.response?.data?.message || _error.message || 'Network error';
        toast.error(errorMsg);
        setError(errorMsg);
      }
      setShowConfirmation(false);
    } finally {
      setLoading(false);
    }
  };

  const handleRemoveBid = (index) => {
    const newBids = [...bids];
    newBids.splice(index, 1);
    setBids(newBids);
    toast.success('Bid removed successfully!');
  };

  const handleBack = () => {
    navigate(-1);
  };

  const handleLoginRedirect = () => {
    navigate('/login');
  };

  // Prepare bet details for confirmation modal
  const getBetDetails = () => {
    const formatDate = (date) => {
      const d = new Date(date);
      const year = d.getFullYear();
      const month = d.toLocaleString('en-US', { month: 'short' });
      const day = d.getDate().toString().padStart(2, '0');
      return `${year}-${month}-${day}`;
    };

    return {
      gameName: gameData?.game_name || "SITA MORNING",
      gameType: gameTypeName,
      totalBets: bids.length,
      totalPoints: bids.reduce((sum, bid) => sum + parseInt(bid.points || 0), 0),
      session: playTime,
      date: formatDate(new Date()),
      bids: bids,
      isSangam: isSangamGame,
      isJodi: isJodiDigit,
      isMotor: isMotorGame
    };
  };

  // Check if market selection should be disabled
  const isMarketDisabled = (session) => {
    if (session === "Open") {
      return !marketStatus.openMarketOpen;
    }

    if (session === "Close") {
      return !marketStatus.closeMarketOpen;
    }

    return false;
  };

// Get market status message
const getMarketStatusMessage = () => {
  const now = currentTime.toLocaleTimeString();

  if (playTime === "Open") {
    if (!marketStatus.openMarketOpen) {
      return `Open market betting is CLOSED. Bets stop 5 minutes before open time (${gameData?.open_time}). Current time: ${now}`;
    }

    return `Open market betting is OPEN. Bets close 5 minutes before open time (${gameData?.open_time}). Current time: ${now}`;
  }

  if (playTime === "Close") {
    if (!marketStatus.closeMarketOpen) {
      return `Close market betting is CLOSED. Bets stop 5 minutes before close time (${gameData?.close_time}). Current time: ${now}`;
    }

    return `Close market betting is OPEN. Bets close 5 minutes before close time (${gameData?.close_time}). Current time: ${now}`;
  }

  return "";
};

  // Show login prompt if no token
  if (!authService.getToken()) {
    return (
      <div className="betting-page">
        <Toaster position="top-right" />
        <div className="betting-container">
          <h2>Authentication Required</h2>
          <div className="error-message">
            You need to be logged in to place bets.
          </div>
          <div className="auth-buttons">
            <button className="login-btn" onClick={handleLoginRedirect}>
              Go to Login
            </button>
            <button className="back-btn" onClick={handleBack}>
              ← Back
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="betting-page">
      <Toaster position="top-right" />
      
      {/* Confirmation Modal */}
      <ConfirmationModal
        isOpen={showConfirmation}
        onClose={() => setShowConfirmation(false)}
        onConfirm={handleConfirmBet}
        betDetails={getBetDetails()}
      />
      
      {/* BREADCRUMB */}
      <div className="breadcrumb">
        <span>Home</span>
        <span>›</span>
        <span>{gameData?.game_name || "Game"}</span>
        <span>›</span>
        <span className="active">{gameTypeName}</span>
      </div>

      <div className="betting-container">
        <h2>Place Your Bet</h2>

        {/* USER INFO */}
        {userData && (
          <div className="user-info">
            <span>Welcome, {userData.user_name || userData.mobile}</span>
          </div>
        )}

        {/* MARKET STATUS */}
        <div className={`market-status ${isMarketDisabled(playTime) ? 'closed' : 'open'}`}>
          {getMarketStatusMessage()}
        </div>

        {/* SELECT GAME TYPE - Only for non-Sangam, non-Jodi games */}
        {!isSangamGame && !isJodiDigit && !isMotorGame && (
          <div className="form-group">
            <label>Select Game Type:</label>
            <div className="game-type-options">
              <label className="radio-label">
                <input
                  type="radio"
                  name="playTime"
                  checked={playTime === "Open"}
                  disabled={isMarketDisabled("Open")}
                  onChange={() => setPlayTime("Open")}
                />
                <span className="radio-text">Open</span>
                {isMarketDisabled("Open") && <span className="market-closed-label">(Closed)</span>}
              </label>
              
              <label className="radio-label">
                <input
                  type="radio"
                  name="playTime"
                  checked={playTime === "Close"}
                  disabled={isMarketDisabled("Close")}
                  onChange={() => setPlayTime("Close")}
                />
                <span className="radio-text">Close</span>
                {isMarketDisabled("Close") && <span className="market-closed-label">(Closed)</span>}
              </label>
            </div>
          </div>
        )}

        {/* FOR FULL SANGAM */}
      {isFullSangam && (
  <>
    <SearchableDropdown
      label="Open Panna"
      value={openPanna}
      onChange={setOpenPanna}
      options={sangamList}
      placeholder="Select Open Panna"
      disabled={isMarketDisabled(playTime)}
      searchPlaceholder="Search Sangam number"
    />

    <SearchableDropdown
      label="Close Panna"
      value={closePanna}
      onChange={setClosePanna}
      options={sangamList}
      placeholder="Select Close Panna"
      disabled={isMarketDisabled(playTime)}
      searchPlaceholder="Search Sangam number"
    />
  </>
)}

        {/* FOR HALF SANGAM - Updated with both options */}
        {isHalfSangam && (
          <>
            {/* Half Sangam Options Selection */}
            <div className="form-group">
              <label>Select Half Sangam Type:</label>
              <div className="half-sangam-options">
                <label className="radio-label">
                  <input
                    type="radio"
                    name="halfSangamOption"
                    checked={halfSangamOption === 'open_digit_close_pana'}
                    onChange={() => setHalfSangamOption('open_digit_close_pana')}
                    disabled={isMarketDisabled(playTime)}
                  />
                  <span className="radio-text">Open Digit + Close Pana</span>
                </label>
                
                <label className="radio-label">
                  <input
                    type="radio"
                    name="halfSangamOption"
                    checked={halfSangamOption === 'close_digit_open_pana'}
                    onChange={() => setHalfSangamOption('close_digit_open_pana')}
                    disabled={isMarketDisabled(playTime)}
                  />
                  <span className="radio-text">Close Digit + Open Pana</span>
                </label>
              </div>
            </div>

            {/* Open Digit + Close Pana Option */}
            {halfSangamOption === 'open_digit_close_pana' && (
              <>
               <SearchableDropdown
  label="Open Digit (0-9)"
  value={openAnk}
  onChange={setOpenAnk}
  options={singleDigits}
  placeholder="Select Open Digit"
  disabled={isMarketDisabled(playTime)}
  searchPlaceholder="Search digit"
/>

<SearchableDropdown
  label="Close Pana"
  value={closePanna}
  onChange={setClosePanna}
  options={sangamList}
  placeholder="Select Close Pana"
  disabled={isMarketDisabled(playTime)}
  searchPlaceholder="Search Sangam number"
/>
              </>
            )}

            {/* Close Digit + Open Pana Option */}
            {halfSangamOption === 'close_digit_open_pana' && (
              <>
               <SearchableDropdown
  label="Close Digit (0-9)"
  value={closeAnk}
  onChange={setCloseAnk}
  options={singleDigits}
  placeholder="Select Close Digit"
  disabled={isMarketDisabled(playTime)}
  searchPlaceholder="Search digit"
/>

<SearchableDropdown
  label="Open Pana"
  value={openPana}
  onChange={setOpenPana}
  options={sangamList}
  placeholder="Select Open Pana"
  disabled={isMarketDisabled(playTime)}
  searchPlaceholder="Search Sangam number"
/>
              </>
            )}
          </>
        )}

        {/* FOR SINGLE DIGIT */}
        {isSingleDigit && (
  <MultiSelectDropdown
    label="Select Digit"
    values={digits}
    onChange={setDigits}
    options={singleDigits}
    placeholder="Select digit (0-9)"
    disabled={isMarketDisabled(playTime)}
  />
)}

        {/* FOR JODI DIGIT */}
       {isJodiDigit && (
  <MultiSelectDropdown
    label="Select Jodi Digit"
    values={digits}
    onChange={setDigits}
    options={jodiDigitsList}
    placeholder="Select Jodi Digit"
    disabled={isMarketDisabled(playTime)}
  />
)}

        {/* FOR SINGLE PANA */}
     {isSinglePana && (
  <MultiSelectDropdown
    label="Select Single Pana"
    values={digits}
    onChange={setDigits}
    options={singlePanaList}
    placeholder="Select Single Pana"
    disabled={isMarketDisabled(playTime)}
  />
)}

        {/* FOR DOUBLE PANA */}
     {isDoublePana && (
  <MultiSelectDropdown
    label="Select Double Pana"
    values={digits}
    onChange={setDigits}
    options={doublePanaList}
    placeholder="Select Double Pana"
    disabled={isMarketDisabled(playTime)}
  />
)}

        {/* FOR TRIPLE PANA */}
       {isTriplePana && (
  <MultiSelectDropdown
    label="Select Triple Pana"
    values={digits}
    onChange={setDigits}
    options={triplePanaList}
    placeholder="Select Triple Pana"
    disabled={isMarketDisabled(playTime)}
  />
)}

        {/* FOR SP MOTOR */}
     {isSPMotor && (
  <MultiSelectDropdown
    label="Select SP Motor"
    values={digits}
    onChange={setDigits}
    options={singlePanaList}
    placeholder="Select SP Motor"
    disabled={isMarketDisabled(playTime)}
  />
)}

        {/* FOR DP MOTOR */}
      {isDPMotor && (
  <MultiSelectDropdown
    label="Select DP Motor"
    values={digits}
    onChange={setDigits}
    options={doublePanaList}
    placeholder="Select DP Motor"
    disabled={isMarketDisabled(playTime)}
  />
)}

        {/* ENTER POINTS - For all games */}
        <div className="form-group">
          <label>Enter Points:</label>
          <input
            type="number"
            className="form-input no-scroll"
            placeholder="Enter points"
            value={points}
            onChange={(e) => setPoints(e.target.value)}
            min={bidLimits.minBidAmount}
            max={bidLimits.maxBidAmount}
            disabled={isMarketDisabled(playTime)}
          />
          <div className="rate-info">
            Rate: 10 | Min: {bidLimits.minBidAmount} | Max: {bidLimits.maxBidAmount}
          </div>
        </div>

        {/* ADD BID BUTTON */}
        <button 
          className="add-bid-btn"
          onClick={handleAddBid}
          disabled={isMarketDisabled(playTime) || loading}
        >
          ADD BID
        </button>

        {/* BID LIST */}
        {bids.length > 0 && (
          <div className="bid-list">
            <h3>Your Bids ({bids.length})</h3>
            <table className="bid-table">
              <thead>
                <tr>
                  <th>
                    {isFullSangam ? 'Open Panna' : 
                     isHalfSangam ? 'Open Field' : 
                     'Number'}
                  </th>
                  {isSangamGame && <th>Close Field</th>}
                  <th>Points</th>
                  {!isSangamGame && !isJodiDigit && !isMotorGame && <th>Session</th>}
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {bids.map((bid, index) => (
                  <tr key={index}>
                    <td>
                      {bid.type === 'half_sangam' ? (
                        bid.halfSangamOption === 'open_digit_close_pana' ? (
                          <span>{bid.digits} (Open Digit)</span>
                        ) : (
                          <span>{bid.digits} (Open Pana)</span>
                        )
                      ) : (
                        bid.digits
                      )}
                    </td>
                    {isSangamGame && (
                      <td>
                        {bid.type === 'half_sangam' ? (
                          bid.halfSangamOption === 'open_digit_close_pana' ? (
                            <span>{bid.closedigits} (Close Pana)</span>
                          ) : (
                            <span>{bid.closedigits} (Close Digit)</span>
                          )
                        ) : (
                          bid.closedigits
                        )}
                      </td>
                    )}
                    <td>{bid.points}</td>
                    {!isSangamGame && !isJodiDigit && !isMotorGame && <td>{bid.session}</td>}
                    <td>
                      <button 
                        className="remove-btn"
                        onClick={() => handleRemoveBid(index)}
                      >
                        Remove
                      </button>
                    </td>
                  </tr>
                ))}
                <tr className="total-row">
                  <td colSpan={isSangamGame ? 3 : (!isSangamGame && !isJodiDigit && !isMotorGame ? 3 : 2)}>
                    Total Points:
                  </td>
                  <td colSpan={2}>
                    {bids.reduce((sum, bid) => sum + parseInt(bid.points || 0), 0)}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        )}

        {/* PLACE BET BUTTON */}
        <div className="action-buttons">
          <button className="back-btn" onClick={handleBack}>
            ← Back
          </button>
          <button 
            className="place-bet-btn"
            onClick={handlePlaceBetClick}
            disabled={bids.length === 0 || loading || isMarketDisabled(playTime)}
          >
            {loading ? 'Processing...' : 'PLACE BET →'}
          </button>
        </div>

        {/* INFO MESSAGE */}
        <div className="info-message">
          <p><strong>Game Rules:</strong></p>
          <ul>
            {isFullSangam && <li><strong>Full Sangam:</strong> Select or search Open Panna and Close Panna</li>}
            {isHalfSangam && (
              <>
                <li><strong>Half Sangam:</strong> Choose between two options:</li>
                <li>• <strong>Open Digit + Close Pana:</strong> Select Open Digit (0-9) and Close Pana (3-digit)</li>
                <li>• <strong>Close Digit + Open Pana:</strong> Select Close Digit (0-9) and Open Pana (3-digit)</li>
              </>
            )}
            {isJodiDigit && <li><strong>Jodi Digit:</strong> Select or search 2 digits for Jodi (00-99)</li>}
            {isSingleDigit && <li><strong>Single Digit:</strong> Select or search single digit (0-9)</li>}
            {isSinglePana && <li><strong>Single Pana:</strong> Select or search 3-digit Single Pana</li>}
            {isDoublePana && <li><strong>Double Pana:</strong> Select or search 3-digit Double Pana</li>}
            {isTriplePana && <li><strong>Triple Pana:</strong> Select or search Triple Pana (000-999 repeating)</li>}
            {isSPMotor && <li><strong>SP Motor:</strong> Select or search SP Motor number from Single Pana list</li>}
            {isDPMotor && <li><strong>DP Motor:</strong> Select or search DP Motor number from Double Pana list</li>}
            <li>Points must be between {bidLimits.minBidAmount} and {bidLimits.maxBidAmount}</li>
            {isSangamGame && <li>Sangam games are available only for Close market before open time</li>}
            {isJodiDigit && <li>Jodi Digit is available only for Close market before open time</li>}
            {isMotorGame && <li>Motor games follow regular Open/Close market rules</li>}
          </ul>
        </div>
      </div>

      {/* FOOTER */}
      <div className="betting-footer">
        <p>Copyright ©2024 Editor-motto</p>
      </div>
    </div>
  );
};

export default BettingPage;